import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import useReorderQuestions from "./useReorderQuestions";

export default function useAuditQuestions(){

    const {id} = useParams()

    const reorderQuestions = useReorderQuestions()

    return useQuery({

        queryKey: ['design', id, 'audit'],

        queryFn: () => API.get(`/courses/${id}/audit/questions`)
            .then(r => reorderQuestions(r.data)),

        staleTime: 'Infinity',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })
};